module.exports = __webpack_public_path__ + "media/images/countrysquared/za-15c9ba998bb20e009278d9cc472fedf0.svg";